import { useEffect, useState } from 'react';
import { Table, Card, Input, Button, message, Typography, Space, Popconfirm, Tag } from 'antd';
import { SearchOutlined, DeleteOutlined } from '@ant-design/icons';
import api from '../../api/axios';

const { Title } = Typography;

export default function GovBusinessPage() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  const fetchData = async (p = page) => {
    setLoading(true);
    try {
      const params = { page: p, limit: 20 };
      if (search) params.search = search;
      const r = await api.get('/admingov/businesses', { params });
      setData(r.data.data); setTotal(r.data.total);
    } catch { message.error('Xatolik'); }
    setLoading(false);
  };

  useEffect(() => { fetchData(1); }, []);
  useEffect(() => { fetchData(1); }, [search]);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/admingov/businesses/${id}`);
      message.success("O'chirildi"); fetchData();
    } catch { message.error('Xatolik'); }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: 'Nomi', dataIndex: 'name' },
    { title: 'STIR', dataIndex: 'stir', render: v => v || <Tag color="red">Yo'q</Tag> },
    { title: 'Egasi', dataIndex: 'owner_name' },
    { title: 'Telefon', dataIndex: 'owner_phone' },
    { title: 'Viloyat', dataIndex: 'region' },
    { title: 'Status', dataIndex: 'status', render: v => <Tag color={v === 1 ? 'green' : 'red'}>{v === 1 ? 'Aktiv' : 'Nofaol'}</Tag> },
    {
      title: 'Amal', width: 60,
      render: (_, r) => (
        <Popconfirm title="O'chirish?" onConfirm={() => handleDelete(r.id)}>
          <Button size="small" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <Title level={3}>Bizneslar boshqaruvi</Title>
      <Card style={{ borderRadius: 12, marginBottom: 16 }}>
        <Input placeholder="Nomi yoki STIR" prefix={<SearchOutlined />} allowClear value={search} onChange={e => setSearch(e.target.value)} style={{ width: 300 }} />
      </Card>
      <Card style={{ borderRadius: 12 }}>
        <Table
          dataSource={data} columns={columns} rowKey="id" loading={loading} size="small" scroll={{ x: 700 }}
          pagination={{ current: page, total, pageSize: 20, onChange: p => { setPage(p); fetchData(p); } }}
        />
      </Card>
    </div>
  );
}
